/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Badge,
	Table,
	Card,
	CardHeader,
	CardBody,
	CardText,
} from "reactstrap";
import Icon from "../components/Icon";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomerSidebar from "../components/CustomerSidebar";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import { ordersUrl } from "../global/url";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
} from "../global/browserFunctions";

class OrderDetails extends Component {
	constructor(props) {
		super(props);
		document.title = "Order Details";
		this.state = {
			summary: {},
			items: [],
			hasOrders: false,
			loadingText: "Loading....",
			loading: false,
			OrderId: "",
			OrderDate: "",
			OrderStatus: "",
			ShipAddress: "",
			BillAddress: "",
			Subtotal: ""
		};

		if (!getCookie("log")) {
			this.GoToPage("/");
		}
	}

	componentDidMount() {
		this.setState({ loading: true });
		var orderId = getUrlParam("id") || "";
		if (orderId) {
			this.fetchOrder(orderId);
		} else {
			this.setState({ loading: false });
			this.setState({ loadingText: "No order found" });
		}
	}

	GoToPage(path) {
		this.props.history.push(path);
	}

	fetchOrder(id) {
		var self = this;
		var query = "&apiType=fetchOrder&salesorderId=" + id + "&customerId=";
		var customer = getCookie("customid");
		query += customer;

		jquery
			.ajax({
				url: ordersUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary.status == "SUCCESS") {
						var items = (data.data && data.data.items) || [];
						console.log('items', items);
						var summary = (data.data && data.data.summary) || {};
						console.log('summary', summary);
						if (items.length > 0) {
							var Subtotal = 0;
							for (var i in items) {
								Subtotal += parseFloat(items[i].item_amount_fx.value)
								console.log('Subtotal', Subtotal)
							}
							self.setState({ Subtotal: Subtotal.toFixed(2) });
							self.setState({ summary: summary });
							self.setState({ items: items });
							self.setState({ OrderId: summary.tranid.value });
							self.setState({ OrderDate: summary.trandate.value });
							self.setState({ OrderStatus: summary.statusref.text });
							var BillAddress = summary.billaddress.value.replace(
								/\n/g,
								"<br />"
							);
							var ShipAddress = summary.shipaddress.value.replace(
								/\n/g,
								"<br />"
							);
							self.setState({ BillAddress: BillAddress });
							self.setState({ ShipAddress: ShipAddress });
							self.setState({ hasOrders: true });
						} else {
							self.setState({ loadingText: "No order found" });
							self.setState({ hasOrders: false });
						}
					} else {
						self.setState({ loadingText: "No orders found" });
						self.setState({ hasOrders: false });
						showNotification(
							"Sorry",
							"danger",
							"An unknown error occurred. Couldn't fetch your order"
						);
					}
				} catch (error) {
					self.setState({ loadingText: "No orders found" });
					self.setState({ hasOrders: false });
					console.log("error@address", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch your order"
					);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				self.setState({ loadingText: "No orders found" });
				self.setState({ hasOrders: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Check your network"
				);
			});
	}

	render() {
		return (
			<React.Fragment>
				<Header headermenu={this.headermenu} history={this.props.history} />
				<Loader loading={this.state.loading} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem>
								<a href='/orders'>Orders</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>
								Order #{this.state.OrderId}
							</BreadcrumbItem>
						</Breadcrumb>
						{this.state.hasOrders && (
							<React.Fragment>
								<div className='hero-content'>
									<h1 className='hero-heading'>Order #{this.state.OrderId}</h1>
									<div>
										<p className='lead text-muted'>
											Order #{this.state.OrderId} was placed on
											<strong> {this.state.OrderDate}</strong> and is{" "}
											<strong>{this.state.OrderStatus}</strong>.
										</p>
										<p className='text-muted'>
											If you have any questions, please feel free to{" "}
											<a href={`mailto:info@brooklynbicycleco.com?subject=B2B Order #${this.state.OrderId} Question`}>contact us</a>
										</p>
									</div>
								</div>
							</React.Fragment>
						)}
					</Container>
				</section>
				<section className='pb-6'>
					<Container>
						<Row>
							<Col xl='3' lg='4' className='mb-5'>
								<CustomerSidebar history={this.props.history} />
							</Col>
							<Col lg='8' xl='9'>
								{this.state.hasOrders && (
									<React.Fragment>
										<div className='d-none d-md-block cart-header'>
											<Row>
												<Col xs='6'>Item</Col>
												<Col xs='2' className='text-center'>
													Price
												</Col>
												<Col xs='2' className='text-center'>
													Quantity
												</Col>
												<Col xs='2' className='text-center'>
													Total
												</Col>
											</Row>
										</div>
										<div className='cart-body'>
											{this.state.items.map((item, index) => (
												<div key={index} className='cart-item'>
													<Row className='d-flex align-items-center text-left text-md-center'>
														<Col xs='12' md='6'>
															<div className='d-flex align-items-center'>
																<a href={item.item___detailspage_url.value}>
																	<img
																		className='cart-item-img'
																		src={item.item_image_thumbnail_url.value}
																		alt='Item Image'
																	/>
																</a>

																<div className='cart-title text-left'>
																	<a
																		href={item.item___detailspage_url.value}
																		className='text-dark'
																	>
																		<strong>
																			{item.item___displayname.value}
																		</strong>
																	</a>
																</div>
															</div>
														</Col>
														<Col xs='12' md='6' className='mt-4 mt-md-0'>
															<Row className='align-items-center mr-0'>
																<Col md='4'>
																	<Row>
																		<Col
																			xs='6'
																			className='d-md-none text-muted'
																		>
																			Price per item
																		</Col>
																		<Col
																			xs='6'
																			md='12'
																			className='text-right text-md-center'
																		>
																			$
																			{(
																				item.item_fxamount.value /
																				item.item_quantity.value
																			).toFixed(2)}
																		</Col>
																	</Row>
																</Col>
																<Col md='4'>
																	<Row className='align-items-center'>
																		{/* On Small Devices */}
																		<Col
																			xs='7'
																			sm='9'
																			className='text-muted d-md-none'
																		>
																			Quantity <br />
																			Fulfilled <br />
																			Backordered <br />
																		</Col>
																		<Col
																			xs='5'
																			sm='3'
																			md='12'
																			className='text-right text-md-center text-muted d-md-none'
																		>
																			{item.item_quantity.value} <br />
																			{item.item_fulfilled.value} <br />
																			{item.item_backordered.value} <br />

																		</Col>
																		{/* On Large/Medium Devices */}
																		<Col
																			xs='5'
																			sm='3'
																			md='12'
																			className='text-right text-md-center d-none d-md-block d-lg-block d-xl-block'
																		>
																			{item.item_quantity.value} <br />
																			<span className='text-muted' style={{ "fontSize": "0.79rem" }}>
																				Fulfilled : {item.item_fulfilled.value} <br />
																				Backordered : {item.item_backordered.value} <br />
																			</span>
																		</Col>
																	</Row>
																</Col>
																<Col md='4'>
																	<Row>
																		<Col
																			xs='6'
																			className='d-md-none text-muted'
																		>
																			Total price
																		</Col>
																		<Col
																			xs='6'
																			md='12'
																			className='text-right text-md-center'
																		>
																			${item.item_fxamount.value}
																		</Col>
																	</Row>
																</Col>
															</Row>
														</Col>
													</Row>
												</div>
											))}
										</div>
										<Row className='my-5'>
											<Col md='6'>
												<Card className='mb-5'>
													<CardHeader>
														<h6 className='mb-0'>Order Summary</h6>
													</CardHeader>
													<CardBody className='py-4'>
														<CardText tag='table' className='table'>
															<tbody>
																<tr>
																	<th className='py-4'>
																		Order Subtotal
																	</th>
																	<td className='py-4 text-right text-muted'>
																		${this.state.Subtotal}
																	</td>
																</tr>
																<tr>
																	<th className='py-4'>
																		Shipping and handling
																	</th>
																	<td className='py-4 text-right text-muted'>
																		${this.state.summary.shippingcost.value}
																	</td>
																</tr>
																<tr>
																	<th className='py-4'>Tax</th>
																	<td className='py-4 text-right text-muted'>
																		{" "}
																		${this.state.summary.taxtotal_fx.value}
																	</td>
																</tr>
																<tr>
																	<th className='pt-4'>Total</th>
																	<td className='pt-4 text-right h3 font-weight-normal'>
																		${this.state.summary.total_fx.value}
																	</td>
																</tr>
															</tbody>
														</CardText>
													</CardBody>
												</Card>
											</Col>
											<Col md='6'>
												<Card className='mb-4'>
													<CardHeader>
														<h5 className='mb-0'>Shipping Address</h5>
													</CardHeader>
													<CardBody className='py-4'>
														<CardText
															className='text-muted'
															dangerouslySetInnerHTML={{
																__html: this.state.ShipAddress,
															}}
														></CardText>
													</CardBody>
												</Card>
												<Card className='mb-5'>
													<CardHeader>
														<h5 className='mb-0'>Billing address</h5>
													</CardHeader>
													<CardBody className='py-4'>
														<CardText
															className='text-muted'
															dangerouslySetInnerHTML={{
																__html: this.state.BillAddress,
															}}
														></CardText>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</React.Fragment>
								)}

								{!this.state.hasOrders && (
									<React.Fragment>{this.state.loadingText}</React.Fragment>
								)}
							</Col>
						</Row>
					</Container>
				</section>
				<Footer />
			</React.Fragment>
		);
	}
}

export default OrderDetails;
